import React from "react"
import clsx from "clsx"
import I18n from "i18n-js"

class FormFieldPresenterDisplayOnly extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'display_only',
      'tab-pane': true 
    })

   
    return (
      <div className={tabClasses} id='display_only_text'>
        {this.renderDisplayOnlyText()}    
      </div>
    )
  }

  renderDisplayOnlyText() {
    return(
      <div className="col-md-6" key="display_only_text">
        <div className="form-group">
          <label>{I18n.t('display_only_text')}*<span className="ss-help help" title={I18n.t('display_only_helper_text')}></span> </label>
          <div dangerouslySetInnerHTML={{__html: this.props.display_only_text}} className="display_only_text"></div>
        </div>
      </div> 

    )
  }

}

export default FormFieldPresenterDisplayOnly